import axios from '../axios'

/*
 * 评价列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/orderEvaluateRecord/selectPage',
        method: 'post',
        data
    })
}



export const selectByMemberId = (params) => {
    return axios({
        url: '/technologyApply/selectByMemberId',
        method: 'get',
        params
    })
}

export const batchReject = (data) => {
    return axios({
        url: '/technologyApply/batchReject',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/orderEvaluateRecord/batchDelete',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/play/appraise.js